import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { STORIES_TEXT } from "@/lib/landing_text";
import { LocalWinners } from "@/components/LocalWinners";
import { useLandingLang, grantsCta } from "@/components/FundingCaseStudy";

export function SmallBizStories() {
  const { user } = useAuth();
  const lang = useLandingLang();
  const T = STORIES_TEXT[lang];
  return (
    <section className="bg-white border-b border-slate-200" data-testid="sbir-stories-section" data-no-translate lang={lang}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="eyebrow mb-3">{T.eyebrow}</div>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 leading-tight max-w-3xl" data-testid="sbir-title">{T.title[0]} <span className="text-emerald-600">{T.title[1]}</span></h2>
        <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">{T.sub}</p>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 border-t border-l border-slate-200">
          {T.stories.map((s, i) => (
            <div key={s.name} className="border-r border-b border-slate-200 p-8 hover:bg-emerald-50/40 transition-colors fade-up" style={{ animationDelay: `${i * 90}ms` }} data-testid={`sbir-story-${s.name.toLowerCase()}`}>
              <div className="font-mono text-xs text-slate-400">{s.when}</div>
              <div className="font-display text-5xl font-extrabold text-slate-900 mt-5">{s.stat}</div>
              <h3 className="font-display text-xl font-bold text-emerald-700 mt-2">{s.name}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 grid md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-8" data-testid="sbir-phases">
            <div className="text-xs font-semibold text-slate-500 mb-2" data-testid="sbir-phase-title">{T.phaseTitle}</div>
            <div className="grid sm:grid-cols-3 gap-3">
            {T.phases.map(([p, d]) => <div key={p} className="bg-slate-50 border border-slate-200 rounded-lg p-4"><div className="font-mono text-xs uppercase tracking-[0.18em] text-emerald-700">{p}</div><p className="text-sm text-slate-600 mt-1">{d}</p></div>)}
            </div>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link to={grantsCta(user)} data-testid="sbir-cta-button"><Button className="h-11 px-6 rounded-full bg-slate-900 hover:bg-slate-800">{lang === "es" ? "Buscar premios SBIR" : "Find SBIR awards"} <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
          </div>
        </div>
        <LocalWinners lang={lang} />
        <p className="mt-10 text-[11px] leading-relaxed text-slate-400 max-w-4xl" data-testid="sbir-sources">{T.sources}</p>
      </div>
    </section>
  );
}
